import React, { useState } from 'react';
import { RiMenuAddFill, RiDeleteBin5Line } from 'react-icons/ri';
import { FiPlusSquare, FiMinusSquare } from 'react-icons/fi';
import { AiOutlineDelete } from "react-icons/ai";

export const Saclayout = () => {
  const [showLayouts, setShowLayouts] = useState(Array(8).fill(false));
  const [expandedRows, setExpandedRows] = useState({});
  const [topAddClicked, setTopAddClicked] = useState({});

  const data = ['0134', '01345', '0134567'];

  const toggleLayout = (index) => {
    const updated = [...showLayouts];
    updated[index] = !updated[index];
    setShowLayouts(updated);
  };

  const toggleSearch = (outerIdx, innerIdx) => {
    setExpandedRows((prev) => {
      const outer = prev[outerIdx] || {};
      return {
        ...prev,
        [outerIdx]: {
          ...outer,
          [innerIdx]: !outer[innerIdx],
        },
      };
    });
  };

  const handleTopAddClick = (outerIdx) => {
    setTopAddClicked((prev) => ({
      ...prev,
      [outerIdx]: !prev[outerIdx],
    }));

    // Ensure layout is open when AddFile is clicked
    setShowLayouts((prev) => {
      const updated = [...prev];
      updated[outerIdx] = true;
      return updated;
    });
  };

  return (
    <div className="h-96 overflow-y-scroll space-y-4">
      {Array.from({ length: 8 }).map((_, outerIdx) => (
        <div key={outerIdx} className="rounded-md">
          {/* Top bar */}
          <div className="flex gap-2 border-b p-2 items-center">
            <h1>
              <RiMenuAddFill
                className="text-xl text-gray-600 cursor-pointer"
                onClick={() => handleTopAddClick(outerIdx)}
              />
            </h1>
            <h1>
              <AiOutlineDelete className="text-xl text-gray-600" />
            </h1>
            <h1>
              {showLayouts[outerIdx] ? (
                <FiMinusSquare
                  className="text-xl text-blue-500 cursor-pointer"
                  onClick={() => toggleLayout(outerIdx)}
                />
              ) : (
                <FiPlusSquare
                  className="text-xl text-blue-500 cursor-pointer"
                  onClick={() => toggleLayout(outerIdx)}
                />
              )}
            </h1>
            <input type="checkbox" className="w-5 h-5 accent-blue-500" />
            <h1>{`0${outerIdx + 1}`}</h1>
          </div>

          {/* Inner layout */}
          {showLayouts[outerIdx] && (
            <div className="p-3 rounded-md transition-all duration-300">
              {/* Search box if AddFile is clicked */}
              {topAddClicked[outerIdx] && (
                <div className="transition-all duration-300 mb-4 ms-5">
                  <div className="flex border rounded-full w-72">
                    <div className="bg-gray-400 rounded-full px-3 flex items-center">
                      <h1>00</h1>
                    </div>
                    <input
                      type="text"
                      placeholder=" | 00 enter your HSN code"
                      className="flex-1 rounded text-sm px-2"
                    />
                    <button className="bg-gray-400 text-white p-1 px-4 rounded-r-sm text-sm hover:bg-gray-500">
                      Add
                    </button>
                  </div>
                </div>
              )}

              {data.map((code, innerIdx) => (
                <div key={innerIdx}>
                  <div className="flex gap-1 p-2 items-center ms-5">
                    <h1
                      onClick={() => {
                        if (innerIdx < 2) toggleSearch(outerIdx, innerIdx);
                      }}
                      className={`cursor-pointer ${innerIdx < 2 ? '' : 'invisible'}`}
                    >
                      <RiMenuAddFill className="text-xl text-gray-600" />
                    </h1>
                    <h1>
                      <AiOutlineDelete className="text-xl text-gray-600" />
                    </h1>
                    <h1>
                      <FiPlusSquare className="text-xl text-gray-600" />
                    </h1>
                    <input type="checkbox" className="w-5 h-5 accent-blue-500" />
                    <h1>{code}</h1>
                  </div>

                  {/* Show search input per row */}
                  {expandedRows[outerIdx]?.[innerIdx] && (
                    <div className="transition-all duration-300 ms-20 mb-3">
                      <div className="flex border rounded-full w-72">
                        <div className="bg-gray-400 text-gray-700 rounded-full px-4 flex items-center">
                          <h1>01</h1>
                        </div>
                        <input
                          type="text"
                          placeholder=" | 01 enter your HSN code"
                          className="flex-1 rounded text-sm px-2"
                        />
                        <button className="bg-gray-400 text-gray-700 p-1 px-4 rounded-r-sm text-sm hover:bg-gray-500">
                          Add
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}

            </div>
          )}
        </div>
      ))}
    </div>
  );
};
